import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { SubscriptionBanner } from "./SubscriptionBanner";
import { InstallPrompt } from "./InstallPrompt";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { usePageMeta } from "../lib/usePageMeta";
import { SuspensionBanner } from "./SuspensionBanner";
import { NotificationPermissionBanner } from "./NotificationPermissionBanner";

export const Layout = () => {
  usePageMeta({ noindex: true });  // area applicativa: mai indicizzata
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();

  // Auto-chiusura su cambio rotta (utile su mobile dopo click su voce sidebar)
  useEffect(() => { setMobileNavOpen(false); }, [location.pathname]);

  // Lock dello scroll body quando il drawer è aperto
  useEffect(() => {
    if (mobileNavOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => { document.body.style.overflow = prev; };
    }
    return undefined;
  }, [mobileNavOpen]);

  return (
    <div className="min-h-screen flex bg-page">
      <Sidebar mobileOpen={mobileNavOpen} onMobileClose={() => setMobileNavOpen(false)} />

      {/* Overlay scuro su mobile quando il drawer è aperto */}
      {mobileNavOpen && (
        <div
          data-testid="sidebar-overlay"
          onClick={() => setMobileNavOpen(false)}
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          aria-hidden="true"
        />
      )}

      <div className="flex-1 flex flex-col min-w-0">
        <Topbar onMenuToggle={() => setMobileNavOpen((v) => !v)} mobileNavOpen={mobileNavOpen} />
        <SuspensionBanner />
        <NotificationPermissionBanner />
        <main className="flex-1 overflow-x-hidden">
          <SubscriptionBanner />
          <InstallPrompt />
          <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 md:py-8 animate-fade-in">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};
